import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest,} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {UNLEASH_TOGGLES} from '@app/config/FeatureToggleConfig';
import {ConfigService, FeatureTogglesService} from '@dcp/configurator';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {OccConfig} from '@spartacus/core';
import {Observable} from 'rxjs';

/**
 * Http interceptor to add cookies to all cross-site requests.
 */
@UntilDestroy()
@Injectable({providedIn: 'root'})
export class DcpWithCredentialsInterceptor implements HttpInterceptor {
  private withCredentialsEnabled: boolean;

  constructor(protected config: OccConfig, private featureToggleService: FeatureTogglesService, private configService: ConfigService) {
    this.featureToggleService.isEnabled(UNLEASH_TOGGLES.useWithCredentials)
      .pipe(untilDestroyed(this))
      .subscribe(enabled => this.withCredentialsEnabled = enabled);
  }

  /**
   * Intercepts each request and adds the `withCredential` flag to it
   * if it hasn't been added already.
   */
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (this.requiresWithCredentials(request)) {
      request = request.clone({
        withCredentials: true,
      });
    }
    return next.handle(request);
  }

  /**
   * indicates whether the request should use the WithCredentials flag.
   */
  protected requiresWithCredentials(request: HttpRequest<any>): boolean {
    return (
      this.withCredentialsEnabled && (
        this.isOCC(request) || this.configService.isDecoratedStickyEndpoint(request.url))
    );
  }

  private isOCC(request: HttpRequest<any>) {
    return request.url.indexOf(this.occConfig?.prefix) > -1;
  }

  private get occConfig() {
    return this.config.backend.occ;
  }

}

